import Modernizr from 'modernizr';
import * as AOS from "aos";
import * as Rellax from "rellax";
import * as scrollama from "scrollama";
import gsap from "gsap";


/* Parallax and interactive animations */
function initParallax() {
	if (Modernizr.mq('(max-width: 767px)')) {
		return;
	}

	if($('.rellax').length) {
		if(!Modernizr.ie11) {
			new (Rellax as any)('.rellax', {
				center: true
			});
		}
	}

	function handleScrollCallback(action, callback) {
		// callback = { element: DOMElement, index: number, direction: string }
		let $el = $(callback.element);
		let scrollActions = (action === 'enter') ? $el.data('scroll-enter') : $el.data('scroll-exit');

		if (!scrollActions) {
			return;
		}

		if (typeof(scrollActions) === 'string') {
			scrollActions = [{
				action: scrollActions,
				target: $el.data('target'),
				delay: $el.data('delay') || 0
			}];
		}

		for (var i = 0; i < scrollActions.length; i++) {
			let nextSequence:any = scrollActions[i];
			let nextAction:any = nextSequence.action;
			let $nextTarget:any = $el.find(nextSequence.target) || $el;
			let delay:any = nextSequence.delay || 0;

			switch (nextAction) {
				case 'applyClass':
				case 'apply-class':
				case 'add_class':
					gsap.delayedCall(delay, function () {
						let scrollClass = nextSequence.class || $el.data('scroll-class');
						$nextTarget.addClass(scrollClass);
					});
					break;
				case 'removeClass':
				case 'remove-class':
				case 'remove_class':
					gsap.delayedCall(delay, function () {
						let scrollClass = nextSequence.class || $el.data('scroll-class');
						$nextTarget.removeClass(scrollClass);
					});
					break;
				case 'playVideo':
				case 'play_video':
					($nextTarget.get(0) as any).play();
					break;
				case 'pauseVideo':
				case 'pause_video':
					($nextTarget.get(0) as any).pause();
					break;
			}
		}

	}

	function handleScrollEnter(callback) {
		handleScrollCallback('enter', callback);
	};

	function handleScrollExit(callback) {
		handleScrollCallback('exit', callback);
	};

	let scroller = scrollama();

	if ( $('.step').length ) {
		scroller.setup({
			step: '.step',
		}).onStepEnter(handleScrollEnter).onStepExit(handleScrollExit);
	}
}

function initTriggeredInteractions() {
	$('[data-trigger]').on('click', function (e) {
		e.preventDefault();

		var $this = $(this);
		var action = $this.data('trigger');
		var $target = $($this.data('target'));

		switch (action) {
			case 'play-video':
			case 'playVideo':
				($target.get(0) as any).play();
				break;
		}
	});
};

export function init() {
	AOS.init({startEvent: 'load'});

	initParallax();
	initTriggeredInteractions();
}
